import { getBlogArticlePage, getBlogArticlePages } from "../../core/api/blog";

import { BLOG_SLUG } from "../../core/urls";
import BlogArticlePage from "../../components/BlogArticlePage";
import Head from "next/head";
import Metatags from "../../components/Metatags";
import React from "react";
import { getFooter } from "../../core/api/core";
import { getMenu } from "../../core/api/menu";

function BlogArticle({ data, menuData, globalData }) {
  const { title, __typename } = data.wagtail.blogArticlePage;

  return (
    <>
      <Head>
        <title>Reskinned | {title}</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.blogArticlePage.metaTitle}
        metaDescription={data.wagtail.blogArticlePage.metaDescription}
      />
      <BlogArticlePage
        pageData={data.wagtail.blogArticlePage}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

export default BlogArticle;

export async function getStaticProps({ params }) {
  const { data } = await getBlogArticlePage(params.slug);
  const menuData = await getMenu();
  const globalData = await getFooter();

  if (!data.wagtail.blogArticlePage) {
    return { notFound: true };
  }

  return {
    props: {
      data,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  const { data, errors } = await getBlogArticlePages();

  const paths = errors.length
    ? []
    : data.wagtail.blogArticlePages.map((blogArticlePage) => {
        return `/${BLOG_SLUG}/${blogArticlePage.slug}`;
      });

  return {
    paths,
    fallback: "blocking",
  };
}
